import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest, } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { SessionService } from '../services/session.service';
import { environment } from 'src/environments/environment';
import { UserService } from '../services/user.service';
import { SpectatorService } from 'src/app/modules/live-chat/services/spectator.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(
    private sessionService: SessionService,
    private userService: UserService,
    private spectatorService: SpectatorService
  ) {
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    try {
      if (!request.url.startsWith(environment.PIPELINE_BFF_URL)) {
        return next.handle(request);
      }

      const headers = this.getAuthorizationHeader(request.headers);
      const newRequest = request.clone({headers});

      return next.handle(newRequest);
    } catch (error) {
      return throwError(() => new Error('User not found'));
    }
  }

  getAuthorizationHeader(headers: HttpHeaders) {
    let token = '';

    if (this.sessionService.sessionToken) {
      token = this.sessionService.sessionToken;
      this.sessionService.resetToken();
    }

    const hash = this.userService.generateHashUser()
    if (hash) {
      token = hash;
    }

    if (!token) {
      return headers;
    }
    const authHeaders = headers.append('Authorization', token);
    
    if (this.spectatorService.spectatorToken) {
      const globalAuth = this.spectatorService.spectatorToken;
      return authHeaders.append('X-Global-Auth', globalAuth);
    }
    
    return authHeaders;
  }
}
